import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { VypisyudajuDokumentInfoDto } from '@gov-nx/api';
import { saveToDocumentsQuery, usePoMutation } from '@gov-nx/api';
import { GovError } from '@gov-nx/core/app';
import { useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';

export interface SaveToDocumentsProps {
	onError: (error: Error) => void;
	onSuccess: (document: VypisyudajuDokumentInfoDto) => void;
}

export const useSaveToDocuments = ({
	onSuccess,
	onError,
}: SaveToDocumentsProps) => {
	const { t } = useTranslation([LocalizeNameSpaceTypes.Service]);
	const { toastMessageSuccess } = useMessageEvents();
	const queryClient = useQueryClient();

	const saveToDocuments = usePoMutation({
		mutationFn: saveToDocumentsQuery,
		onError: (error) => {
			onError &&
				onError(
					new GovError(
						`Error: An unexpected error occurred while saving file to documents. ${error}`
					)
				);
		},
		onSuccess: async (document) => {
			await queryClient.invalidateQueries({ queryKey: ['documents'] });

			onSuccess && onSuccess(document);
			toastMessageSuccess(
				t('soubor.ulozeni-dokumentu.uspesne', {
					namespace: LocalizeNameSpaceTypes.Service,
					fileName: document.nazev,
				}),
				{},
				document.nazev
					? [
							{
								title: document.nazev,
								page: PageCode['moje-soubory'],
								attrs: [{ documentId: document.id }],
							},
						]
					: []
			);
		},
	});
	return { saveToDocuments };
};
